import { createAuthProvider } from '@internal/ui-kit/providers/authProvider'

/** Admin app access requires the `admin` or `superadmin` scope — a valid token alone isn't enough. */
const ADMIN_SCOPES = ['admin', 'superadmin']

export const { authProvider, startGoogleLogin, signUp, requestPasswordReset, resetPassword, changePassword } =
  createAuthProvider({
    requiredScopes: ADMIN_SCOPES,
    accessDeniedMessage: 'Your account does not have admin access.',
  })
